import {
  GET_ALL_CITY_GROUPS,
  CREATE_CITY_GROUP,
  UPDATE_CITY_GROUP,
  DELETE_CITY_GROUP,
} from '../constants/ActionTypes'
import {
  GET_ALL_CITY_GROUPS_QUERY,
  CREATE_CITY_GROUP_QUERY,
  UPDATE_CITY_GROUP_QUERY,
  DELETE_CITY_GROUP_QUERY,
} from '../constants/QueryTypes'
import query from '../services/GraphQLService'

export const getAllCityGroups = () => (dispatch) => {
  query('query', GET_ALL_CITY_GROUPS_QUERY, {}).then(({ data }) => {
    dispatch({ type: GET_ALL_CITY_GROUPS, payload: data.AllCityGroups })
  })
}

export const createCityGroup = (name, description, cityIds) => (dispatch) => {
  return new Promise((resolve, reject) => {
    query('mutate', CREATE_CITY_GROUP_QUERY, { name, description, cityIds })
      .then(({ data }) => {
        dispatch({ type: CREATE_CITY_GROUP, payload: data.createCityGroup })
        resolve(data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}

export const updateCityGroup =
  (id, name, description, cityIds) => (dispatch) => {
    return new Promise((resolve, reject) => {
      query('mutate', UPDATE_CITY_GROUP_QUERY, {
        id,
        name,
        description,
        cityIds,
      })
        .then(({ data }) => {
          dispatch({ type: UPDATE_CITY_GROUP, payload: data.updateCityGroup })
          resolve(data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

export const deleteCityGroup = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    query('mutate', DELETE_CITY_GROUP_QUERY, { id })
      .then(({ data }) => {
        dispatch({ type: DELETE_CITY_GROUP, payload: id })
        resolve(data)
      })
      .catch((e) => {
        reject(e)
      })
  })
}
